module.exports = __webpack_public_path__ + "img/carbon_reminder.fcccf7b0.svg";